import { atom } from "recoil";

export const activeOrganizationIdState = atom<string | undefined>({
  key: "active-organization-id",
  default: undefined,
});
